import React, { useEffect, useState } from "react";
import useAxios from "../../../../Utils/useAxios";
import { useParams } from "react-router-dom";
import FormCapaianIK from "../components/FormCapaianIK";
import { toast } from "react-toastify";
import { admins, timeToast } from "../../../../Constant";
import { FORM_TYPE } from "../../../../Constant/FormType";
import getCapaianIKByID from "../services/getCapaianIKByID";
import FormEdit from "../components/FormEdit";
import { getUser } from "../../../../Utils/externalFunctions";

const EditCapaianIK = () => {
  const isAdmin = admins.includes(getUser());
  const axiosInstance = useAxios();
  const { capaianIKId } = useParams();
  const [formCapaianIK, setFormCapaianIK] = useState();

  useEffect(() => {
    getCapaianIK();
  }, []);

  const getCapaianIK = () => {
    getCapaianIKByID(axiosInstance, capaianIKId).then((res) => {
      setFormCapaianIK(res.data)
    })
  };

  return (
    <>
      {
        isAdmin ? 
        (
          <FormCapaianIK
            formCapaianIK={formCapaianIK}
            setFormCapaianIK={setFormCapaianIK}
            formType={FORM_TYPE.Edit}
            />
          ) : (
          <FormEdit
            formCapaianIK={formCapaianIK}
            setFormCapaianIK={setFormCapaianIK}
          />
        )

        
      }
    </>
  );
};

export default EditCapaianIK;
